import React from 'react'
import './errormessage.scss'

const JezErrorMessage = (props) => {
    return (
        <div className={'profile-error-message'} {...props}>
            {props.children}
        </div>
    )
}

export default JezErrorMessage